import React from 'react';
import { TextArea } from 'semantic-ui-react';

/**
 * TextfieldComponent is a reusable component that renders a textfield.
 * @param {string} value - The value/label of the textfield.
 * @param {function} onChange - The function that handles the change state of the textfield.
 * @param {string} className - The class name of the textfield.
 * @param {function} onKeyPress - The function that handles the key press event of the textfield.
 * @param {number} rows - The number of rows in the textfield.
 * @param {string} dataCy - The data-cy attribute for the cypress scripts.
 * **/

const TextfieldComponent = ({ value, onChange, className, onKeyPress, rows, dataCy,disabled,placeholder,error,helperText,required }) => {
  return (
    
      <TextArea
        rows={rows}
        value={value}
        className={className}
        data-cy={dataCy}
        onChange={(e) => {
          onChange(e.target.value);
            }}
        onKeyPress={onKeyPress}
        disabled={disabled}
        placeholder={placeholder}
        error={error} // Pass error prop to highlight the field if needed
        helperText={helperText} // Pass helperText prop for additional information
        required={required} // Make the field compulsory if required prop is true

      />
    
  );
}

export default TextfieldComponent;